/** Lightweight Markdown → HTML — supports H1/H2/H3, paragraphs, bold, italic,
 *  inline code, links, and ordered/unordered lists. Used by:
 *    - ArticleDetail.jsx (public reading)
 *    - AdminArticles.jsx (live preview in editor)
 *  Keeping it inline (no react-markdown dep) keeps the bundle small for what
 *  is, in practice, a curated dozen articles. Always sanitize the OUTPUT with
 *  DOMPurify before injecting into the DOM — this helper does NOT sanitize. */
export const renderMarkdown = (md) => {
  if (!md) return "";
  const lines = md.split("\n");
  const html = [];
  let inList = false;
  const close = () => { if (inList) { html.push("</ul>"); inList = false; } };
  const inline = (s) =>
    s
      .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
      .replace(/\*([^*]+)\*/g, "<em>$1</em>")
      .replace(/`([^`]+)`/g, "<code>$1</code>")
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-[#C5A880] hover:underline">$1</a>');

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (line.startsWith("# ")) { close(); html.push(`<h1 class="font-display text-3xl md:text-4xl mt-10 mb-5 text-[#F5F2EE]">${inline(line.slice(2))}</h1>`); continue; }
    if (line.startsWith("## ")) { close(); html.push(`<h2 class="font-display text-2xl md:text-3xl mt-10 mb-4 text-[#F5F2EE]">${inline(line.slice(3))}</h2>`); continue; }
    if (line.startsWith("### ")) { close(); html.push(`<h3 class="font-display text-xl mt-8 mb-3 text-[#C5A880]">${inline(line.slice(4))}</h3>`); continue; }
    if (line.startsWith("- ") || line.startsWith("* ")) {
      if (!inList) { html.push('<ul class="list-disc pl-5 space-y-2 my-4 text-[#DCD7D2]">'); inList = true; }
      html.push(`<li>${inline(line.slice(2))}</li>`); continue;
    }
    if (/^\d+\.\s/.test(line)) {
      if (!inList) { html.push('<ol class="list-decimal pl-5 space-y-2 my-4 text-[#DCD7D2]">'); inList = true; }
      html.push(`<li>${inline(line.replace(/^\d+\.\s/, ""))}</li>`); continue;
    }
    if (!line.trim()) { close(); continue; }
    close();
    html.push(`<p class="text-[#DCD7D2] leading-relaxed my-4">${inline(line)}</p>`);
  }
  close();
  return html.join("\n");
};
